import signitic from './signitic/mark.svg?raw';
import user from './user/mark.svg?raw';
import surfer from './surfer/mark.svg?raw';
import iconosquare from './iconosquare/mark.svg?raw';
import humanlinker from './humanlinker/mark.svg?raw';
import ubic from './ubic/mark.svg?raw';
import nocrm from './nocrm/mark.svg?raw';
import fourdem from './4dem/mark.svg?raw';
import mailingwork from './mailingwork/mark.svg?raw';
import rapidmail from './rapidmail/mark.svg?raw';
import sarbacane from './sarbacane/mark.svg?raw';

export const productIcons = Object.freeze({
  signitic,
  user,
  surfer,
  iconosquare,
  humanlinker,
  ubic,
  nocrm,
  '4dem': fourdem,
  mailingwork,
  rapidmail,
  sarbacane,
});
